import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import type { Config } from '..';
import content from '../../../../.contentlayer/generated/PrivacyPolicy/privacyPolicy__en-DE.mdx.json';

export const config: Config = {
  layout: { ...sharedConfig['en-DE'].layout },
  seo: {
    ...sharedConfig['en-DE'].seo,
    title: 'Privacy Policy - Lemonade Insurance',
    metaTitle: 'Privacy Policy - Lemonade Insurance',
    description:
      "Lemonade's Privacy Policy is in place to protect you. Keeping your information private and secure is of utmost importance to us - we will never share or sell your information for marketing purposes and maintain strict electronic and procedural safeguards to protect your information at all times.",
  },
  MDXContent: content as DocumentTypes,
};
